export default {
  primary: {
    main: "#ffc107",
    light: "#ffca28",
    contrastText: "#333"
  }
};
//# sourceMappingURL=amber.js.map